import { UserRole } from '@front-app/services/UserApi/UserModel';

export type MemberTypeOption = UserRole.ADMINISTRATOR | UserRole.MEMBER | UserRole.NONE;

export enum INVITE_STEP {
	ADD_INVITEES,
	NOTIFICATION_SELECT,
	EMAIL_TEXT,
}

export enum INVITE_BY {
	EMAIL_ADDRESS,
	TIMEDRIGHT_CONTACTS,
}

export interface MembersToAdd {
	type: INVITE_BY;
	emailsList: string;
	members: string[];
	role: MemberTypeOption;
}
